// extracted by mini-css-extract-plugin
export default {"closeContainer":"_3XHy1DRm","absCloseBtn":"_1OLscs8U"};